const preloader = document.querySelector(".preloader");

const showPreloader = () => {
    if (!preloader) {
        return;
    }
    preloader.classList.remove("preloader_hide");
    preloader.classList.add("preloader_show");
};

const hidePreloader = () => {
    if (!preloader) {
        return;
    }
    preloader.classList.remove("preloader_show");
    preloader.classList.add("preloader_hide");
};

export { showPreloader, hidePreloader };
